// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__mY0dA","menu":"Nav_menu__b8KTH","bag":"Nav_bag__aiilv","badge":"Nav_badge__nTK24","link":"Nav_link__1f9Qu"};